import script from "./DeleteDir.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteDir.vue?vue&type=script&setup=true&lang=js"

import "./DeleteDir.vue?vue&type=style&index=0&id=9cbd8d8c&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cbd8d8c"]])

export default __exports__